module.exports = __webpack_public_path__ + "static/img/bg_two.442038ca.png";